import { initializeApp, type FirebaseOptions } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import log from 'loglevel';
import {
  FIREBASE_API_KEY,
  FIREBASE_APP_ID,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID,
} from '../constants';

let isInitialized = false;

/**
 * Initialize Firebase module.
 */
export const initialize = async () => {
  if (isInitialized || !FIREBASE_API_KEY) {
    return;
  }

  const options: FirebaseOptions = {
    apiKey: FIREBASE_API_KEY,
    appId: FIREBASE_APP_ID,
    authDomain: FIREBASE_AUTH_DOMAIN,
    projectId: FIREBASE_PROJECT_ID,
  };

  const app = initializeApp(options);
  getAuth(app);

  log.debug('Initialized Firebase');

  isInitialized = true;
};

/**
 * Returns if Firebase is available and initialized.
 */
export const isReady = () => {
  return isInitialized;
};
